const index = () => import(/* webpackChunkName: "herb" */ './Index');
const manager = () => import(/* webpackChunkName: "herb" */ './managerIndex');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/guide/guide/v2022/index',
      name: 'guide_guide_v2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/guide/guide/v2022/router.js